module.exports = __webpack_public_path__ + "img/1_020.40099a3e.jpg";